export type HochrechnungSourceEntity = 'auftrag' | 'rechnung';

export const sourceEntityOptions = [
    { value: 'auftrag', label: 'Auftrag' },
    { value: 'rechnung', label: 'Rechnung' },
];

export type HochrechnungPeriod = 'calendaryear' | 'accountingyear';

export const periodOptions = [
    { value: 'calendaryear', label: 'Kalenderjahr' },
    { value: 'accountingyear', label: 'Buchhaltungsjahr' },
];

export interface FilterValues {
    sourceEntity: HochrechnungSourceEntity;
    period: HochrechnungPeriod;
}
